import { useUserStore } from '@/stores/user';
import { watch } from 'vue';
import { useAnalytics } from './analytics';

export function useAnalyticsUserId() {
  const userStore = useUserStore();
  const { addCustomGaEvent } = useAnalytics();

  // `backstage_user_id` is the key read by the GTM variable behind the GA4 'Backstage User ID' custom dimension.
  // `flush: 'sync'` publishes the ids before any event pushed right after the profile is set (e.g. `login`).
  watch(
    () => userStore.userProfile?.user?.id,
    (userId) => addCustomGaEvent({ user_id: userId ?? null, backstage_user_id: userId ?? null }),
    { immediate: true, flush: 'sync' },
  );
}
